// Real customer testimonials go here once we have them.
// Each entry: { quote: string, name: string, business: string }
// IMPORTANT: Never invent quotes or names - leave this empty until real ones are collected.
export const testimonials = [];
